import { css } from 'styled-components'
import styled from 'styled-components/native'

import { Flex1SafeAreaView } from './CommonViews'

const padding = css`
  padding: 0 24px;
`

/**
 * Common template styles used (padding, margin, etc)
 */

export const ContentAreaScrollView = styled.ScrollView`
  ${padding}
`

export const ContentAreaView = styled.View`
  ${padding}
`

export const ContentAreaFlex1SafeAreaView = styled(Flex1SafeAreaView)`
  ${padding}
`
